import { render, staticRenderFns } from "./orderDIFOTContactListWidget.vue?vue&type=template&id=f0bbe126&"
import script from "./orderDIFOTContactListWidget.vue?vue&type=script&lang=js&"
export * from "./orderDIFOTContactListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports